import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useTranslate } from './TranslationText';
import { limit, onSnapshot, query, where, orderBy } from 'firebase/firestore';
import { RankListRequestRef, ScoringRequest } from '../firebase/collections';
import { getFlagUrl } from '../helper/getFlagUrl';
const TabStyle = {
    display: "block",
    marginRight: 0,
    marginLeft: 0,
    padding: "10px 20px",
    textAlign: "center",
    background: "#ffffff",
    cursor: "pointer",
    color: "#000",
    transition: "all 300ms",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    fontSize: 15,
};
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function JudgeList({ showID = "", setFireStoreDataJugdes = () => console.log('nothing'), isShowEntryDetailsPage = false, isFirebaseEnabled = false }) {
    const { currentLanguage } = useSelector((state) => state.studBookSlice);

    const {
        showJudgesData,
        showClassRankListData,
    } = useSelector((state) => state.showsSlice);
    const [viewHorseBox, setViewHorseBox] = useState(false);
    const [inArenaHorse, setInArenaHorse] = useState([]);
    const [inArenaHorseId, setInArenaHorseId] = useState('');

    // firestore
    const [firestoreData, setFireStoreData] = useState([]);


    const filterCollection = async () => {
        const twentyMinutesAgo = new Date();
        twentyMinutesAgo.setMinutes(twentyMinutesAgo.getMinutes() - 30);
        const q = query(
            RankListRequestRef,
            where("ShowId", "==", showID), // Filter by AuctionHorseID
            where("TimeStamp", ">=", twentyMinutesAgo),
            orderBy('TimeStamp', 'desc'),
            limit(1),
        );
        return q;
    };
    const filterScoring = async () => {
        const q = query(
            ScoringRequest,
            where("ShowId", "==", showID),
            orderBy('TimeStamp', 'desc'),
            limit(1),
        );
        return q;
    }
    const resetInArenaHorseIfRequired = (firestoreData, inArenaHorse) => {
        if (Array.isArray(inArenaHorse) && inArenaHorse.length > 0) {
            const currentInArenaHorse = inArenaHorse[0]?.TimeStamp?.seconds;
            const currentIncomingRankListUpdate = firestoreData?.TimeStamp?.seconds;
            if (currentIncomingRankListUpdate > currentInArenaHorse) {
                setViewHorseBox(false);
                console.debug('63 empty In Arena', inArenaHorse);
                setInArenaHorse([]);
            }
        }
    }


    const fetchData = async () => {
        try {
            // Now, proceed to fetch data from Firestore
            const q = await filterCollection();

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newData = [];
                querySnapshot.forEach((doc) => {
                    newData.push(doc.data());
                });
                setFireStoreData(newData[newData.length - 1]);
                setFireStoreDataJugdes(newData[newData.length - 1]);
            });

            return unsubscribe;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchScoring = async () => {
        try {
            // Now, proceed to fetch data from Firestore
            const q = await filterScoring();
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newData = [];
                querySnapshot.forEach((doc) => {
                    newData.push(doc.data());
                });

                setInArenaHorse((prev) => {
                    if (newData[0]?.Action == 5) {
                        if (prev[0]?.HorseId === newData[0].HorseId) {
                            return newData;
                        }
                    }
                    else if (newData[0]?.Action == 1) {
                        return newData;
                    }
                    return prev;
                });

            });

            return unsubscribe;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    useEffect(() => {
        if (!isFirebaseEnabled || !showID) {
            setInArenaHorse([]);
            setFireStoreData([]);
            return;
        }

        let unsubCollection;
        let unsubScoring;

        fetchData().then((unsub) => {
            unsubCollection = unsub;
        });
        fetchScoring().then((unsub) => {
            unsubScoring = unsub;
        });

        return () => {
            if (unsubCollection) unsubCollection();
            if (unsubScoring) unsubScoring();
        };
    }, [isFirebaseEnabled, showID])

    useEffect(() => {
        console.debug('In Arena Horse Is ', inArenaHorse, 'Firestore', firestoreData);
        if (inArenaHorse.length > 0) {
            if (inArenaHorse[0].Action == 1) {
                setInArenaHorseId(inArenaHorse[0].HorseId)
                setViewHorseBox(true);
            } else if (inArenaHorse[0]?.Action == 5) {
                if (inArenaHorseId === inArenaHorse[0]?.HorseId) {
                    setViewHorseBox(false);
                    setInArenaHorseId('');
                    setInArenaHorse([]);
                }
            }
        }
        resetInArenaHorseIfRequired(firestoreData, inArenaHorse)

    }, [firestoreData, inArenaHorse])

    const { translate } = useTranslate();

    const [judgesHovered, setJudgesHovered] = useState(false);
    const [judgesActive, setJudgesActive] = useState(true);

    const [dcHovered, setDcHovered] = useState(false);
    const [dcActive, setDcActive] = useState(false);

    const [ringMasterHovered, setRingMasterHovered] = useState(false);
    const [ringMasterActive, setRingMasterActive] = useState(false);
    const [selectedSearchType, setSelectedSearchType] = useState("2");

    const handleSelectedSearchType = (e) => {
        setSelectedSearchType(e);
    };
    if (showJudgesData.length == 0) {
        return
    }

    return <div className="col-xl-4 col-lg-4 col-md-12 mb-main ">
        <div className='h-100' >
            <div className="row ">
                {
                    // judges buttons
                }
                {showJudgesData.filter((a) => a.role === "2").length > 0 &&
                    <div
                        className={'col-4  text-center mb-main  pe-sm-0 pe-0'}
                        style={{ cursor: 'pointer' }}
                        id="second_most_used_services"
                        onClick={() => {
                            setJudgesActive(true);
                            setDcActive(false);
                            setRingMasterActive(false);
                            handleSelectedSearchType("2");
                        }}
                    >
                        <span className={`${judgesActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate("web.judges", "Judges")}</span>

                        <div className="service_bar_underline" style={judgesActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                    </div>
                }
                {showJudgesData.filter((a) => a.role === "1").length > 0 &&
                    <div
                        className={'col-4  text-center mb-main px-0'}
                        id="second_most_used_services"
                        style={{ cursor: 'pointer' }}

                        onClick={() => {
                            setJudgesActive(false);
                            setRingMasterActive(false);
                            setDcActive(true);
                            handleSelectedSearchType("1");
                        }}
                    >
                        <span className={`${dcActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate("web.dc", "DC")}</span>

                        <div className="service_bar_underline" style={dcActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                    </div>
                }
                {showJudgesData.filter((a) => a.role === "0").length > 0 &&
                    <div
                        className={'col-4  text-center mb-main  px-0'}
                        id="second_most_used_services"
                        style={{ cursor: 'pointer' }}

                        onClick={() => {
                            setJudgesActive(false);
                            setDcActive(false);
                            setRingMasterActive(true);
                            handleSelectedSearchType("0");
                        }}
                    >
                        <span className={`${ringMasterActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate("web.ringMaster", "Ring Master")}</span>

                        <div className="service_bar_underline" style={ringMasterActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                    </div>
                }


                {
                    // judges data
                }
                {showJudgesData.length > 0 && (
                    <div
                        className="col-lg-12 col-md-12 col-sm-12  mb-main"

                    >
                        <div className='bg-white p-main border-15 p-3 h-100'>

                            {!!showJudgesData &&
                                showJudgesData.filter((a) => a.role === selectedSearchType)
                                    .length > 0 ? (
                                showJudgesData
                                    .filter((a) => a.role === selectedSearchType)
                                    .map((item, i) => (
                                        <div key={i} className="JudgesTableRow ">
                                            {selectedSearchType === "2" && (
                                                <div className="showDetailsJudesLetter ">
                                                    {item.letter}
                                                </div>
                                            )}

                                            <img
                                                className="countryFlageImg rounded me-3"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = `${BaseURL}/assets/img/whitebgimg.png`;
                                                }}
                                                src={getFlagUrl(item.countryFlag)}
                                                alt={item.countryName} />

                                            <div className="showDetailsJudesName ">
                                                {item.name}
                                            </div>
                                        </div>
                                    ))
                            ) : (
                                <div
                                    className="row text-danger text-center "
                                    style={{ position: "relative", top: 98 }}
                                >
                                    {translate("web.nodataFound", "No Data Found !")}
                                </div>
                            )}
                        </div>

                    </div>
                )}


                {/* {isShowEntryDetailsPage == false &&
                    <div
                        className="col-lg-12 col-md-12 col-sm-12"
                        style={{
                            maxHeight: 500,
                            overflowX: "hidden",
                        }}
                    >
                        {viewHorseBox && inArenaHorse.map((horse, index) => {
                            return (
                                <div className='bg-white p-main border-15 p-3 text-center '>
                                    <h5 className="card-title  fw-bold text-dark mb-1"> {translate("web.currentHorseInArena", "Current Horse In Arena")}</h5>
                                    <div className='mx-1' style={{ background: ' var(--mainGold)', width: 100, height: 100, color: 'white', borderRadius: '50%', fontSize: 32, display: 'inline-flex', alignItems: 'center', justifyContent: "center" }} >{horse?.HorseNumber}</div>
                                    <h6 className="card-title mt-1  fw-bold text-dark"> {currentLanguage == 'en' ? horse?.HorseInArenaName : horse?.HorseInArenaNameAr}</h6>
                                    <h6 className="card-title mt-1 horseCardDescription  rtl" style={{ fontSize: 'unset' }}>{currentLanguage == 'en' ? horse?.OwnerName : horse?.OwnerNameAr}</h6>
                                </div>
                            )
                        })}

                        {!!firestoreData && firestoreData?.RankScoringList?.length > 0 && (
                            <div className='shadow  my-3 bg-white px-3 py-3' style={{ borderRadius: 25 }}>
                                <h5 className="card-title  fw-bold text-dark text-center mb-3">
                                    {translate("web.currentClassRank", "Current class rank")} <br />
                                    {currentLanguage == 'en' ? firestoreData?.ClassName : firestoreData?.ClassNameAr}
                                </h5>
                                <table
                                    className="table tablenominwidth table-striped table-bordered rtl horseResultTable "
                                    style={{ direction: currentLanguage == "ar" ? "rtl" : "ltr", width: '100%', minWidth: 0 }}
                                >
                                    <thead className='text-center'
                                        style={{
                                            backgroundColor: "#c89c66",
                                            color: "white",
                                        }}
                                    >
                                        <th>
                                            {translate("web.rank", "Rank")}
                                        </th>
                                        <th>{translate("web.horseName", "Horse Name")}</th>
                                        <th>{translate("web.totalPoints", "Total Points")}</th>
                                    </thead>
                                    <tbody className='text-center'>
                                        {firestoreData?.RankScoringList?.map((item, i) => (
                                            <tr key={i}>
                                                <td className='bold'>{item.HorseRank}</td>
                                                <td className='bold'>
                                                    {item.HorseNumber} {item[`HorseName${currentLanguage == 'en' ? '' : 'Ar'}`]}
                                                </td>
                                                <td className='bold' >{item?.TotalScore?.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                } */}
            </div>
        </div>
    </div>;
}
